import axios from "axios";
import { userInquiriesUrl } from "../utils";

export const fetchUserInquiries = (userId: string) => {
  return axios.get(userInquiriesUrl(userId));
};
